import React from 'react'
import {Route, Switch} from 'react-router-dom'

import {
  FACE_OFF_GOLDEN_PATH,
  FACE_OFF_GOLDEN_VERSION_PATH,
  FACE_OFF_RUN_PATH,
} from './constants'
import {FaceOffDiff} from './FaceOffDiff'
import {FaceOffGoldenList, FaceOffGoldenVersionView} from './FaceOffGolden'
import {FaceOffRunList} from './FaceOffRunList'
import {FaceOffTheme} from './FaceOffTheme'

/**
 * The Face Off tab: the run list, one run's diff and the golden set, each on
 * its own path under /facial-recognition/face-off.
 */
export const FaceOffTab: React.FC = () => (
  <FaceOffTheme>
    <Switch>
      <Route path={FACE_OFF_RUN_PATH}>
        <FaceOffDiff />
      </Route>
      <Route exact path={FACE_OFF_GOLDEN_PATH}>
        <FaceOffGoldenList />
      </Route>
      <Route path={FACE_OFF_GOLDEN_VERSION_PATH}>
        <FaceOffGoldenVersionView />
      </Route>
      <Route>
        <FaceOffRunList />
      </Route>
    </Switch>
  </FaceOffTheme>
)
